module.exports = __webpack_public_path__ + "rchives-260426a2387213f107ee.png";